import { FC } from "react";
import { RouteNameProps } from "../../../common/route-name/route-name.types";

export const ArchivedRouteName: FC<RouteNameProps> = ({
    data,
}) => {
    return (
        <span>
            Archived
        </span>
    )
}